import { ClubMark } from "@/components/ClubMark";

export function MatchTeamLogo({
  name,
  logoUrl,
  className = "",
}: {
  name: string;
  logoUrl: string | null;
  className?: string;
}) {
  return (
    <ClubMark
      name={name}
      imageUrl={logoUrl}
      initials={2}
      label={`${name} logo`}
      testId="match-team-logo"
      className={`match-team-logo h-7 w-7 shrink-0 text-[0.6rem] font-display ${className}`}
    />
  );
}
